<div class="component-container">
    <ess-spinner *ngIf="mode === 'loading'"></ess-spinner>

    <!--poll context and a key held: the join link, copied right away-->
    <div *ngIf="mode === 'link'" class="copy-link-container">
        <mat-card>
            <div class="card-title"> {{trans.translate(headlineKey)}}</div>
            <div class="dont-share">{{trans.translate(explanationKey)}}</div>
            <div class="copy-link-container">
                <mat-form-field class="field">
                    <input matInput [(ngModel)]="pollUrlForField" [disabled]="true">
                    <button matSuffix mat-icon-button matTooltip="{{trans.translate(copyTooltipKey)}}"
                        (click)="handleClickCopyToClipboard()">
                        <mat-icon>link</mat-icon>
                    </button>
                </mat-form-field>

            </div>
        </mat-card>

    </div>

    <!--no poll context (My Events) or nothing held on this poll: account hint instead of a link (phase 1)-->
    <div *ngIf="mode === 'hint'" class="no-poll-hint">
        {{trans.translate('getPollAccess.noPollHint')}}
    </div>

    <!--the sign-up offer is for anonymous users only (1.10): a signed-in organizer passes the link on-->
    <div *ngIf="mode === 'link' && showSignUp" class="whoo-centered-container-fit-content or-devider"> -- {{trans.translate('getPollAccess.or')}} --</div>

    <div *ngIf="mode !== 'loading' && showSignUp" class="sign-up-container">

        <button mat-raised-button color="warn" (click)="handleClickSignUp()">
            {{trans.translate('getPollAccess.signUpButton')}}</button>

    </div>

</div>
